import React, { useState, useEffect, useRef } from "react";
import Logo from "../../assets/img/new_logo.svg";
import WaitlistPopup from "../../Components/WaitlistPopup";
import { gsap } from "gsap";
function Header() {
  const [showModel, setShowModel] = useState(false);
  const pulseRef = useRef(null);

  useEffect(() => {
    const popupTimer = setTimeout(() => {
      setShowModel(true);
    }, 4000);

    gsap.to(pulseRef.current, {
      filter: "drop-shadow(0 0 12px #ff00cc)",
      duration: 1,
      repeat: -1,
      yoyo: true,
      ease: "power1.inOut"
    });

    return () => clearTimeout(popupTimer);
  }, []);
  return (
    <div className="header">
      <div className="container">
        <div className="d-flex align-items-center justify-content-center">
          <div className="logo bd">
            <a href="/"><img src={Logo} alt="" width={280} height={52} /></a>
            {/* <Link to="/"></Link> */}
          </div>
          <div className="header-button ms-auto">
            <a
              to="/"
              type="button"
              className="btn btn-primary app-btn"
              onClick={() => setShowModel(true)}
            >
              Join the waitlist
            </a>
            <WaitlistPopup
              showModel={showModel}
              setShowModel={setShowModel}
            />
            {/* <a href="#" className="btn btn-primary app-btn" type="button">Join Waitlist</a> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
